export function pendingCustomModelScopeKeys(
  scopeKeys: readonly string[],
  tenantId: string,
  assignableModelIds: readonly string[]
): string[] {
  const assignable = new Set(assignableModelIds);
  return scopeKeys.filter((scopeKey) => {
    if (!scopeKey.startsWith('custom:')) return false;
    const modelKey = scopeKey.slice('custom:'.length);
    return !assignable.has(`${tenantId}-custom-${modelKey}`);
  });
}
